import queries from "./queries";

export default {
    queries
};